import React from 'react';

import CtaWidget from '../../../../CtaWidget';
import { ModalNavCategory } from './MobileNavCategory';

import { MobileNavProps } from '../index';

interface Props extends MobileNavProps {
  isMenuOpen: boolean;
  toggleModal: () => void;
}

export function MobileModal({ navItems, modalMobileCta }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const categoryExpanded = navItems?.find(
    (item: any) => item.fields.isExpanded === true
  ) as any;
  const [titleExpanded, setTitleExpanded] = React.useState<string | undefined>(
    categoryExpanded?.fields?.name
  );

  return (
    <div
      className="relative inset-0 left-0 top-0 z-[1000] flex h-screen w-screen items-center justify-center bg-white p-0"
      aria-label="Navigation menu"
      data-testid="mobile-modal-navigation"
      aria-modal="true"
    >
      <div className="flex h-full w-full flex-col outline-0">
        <div
          className="flex-1 overflow-y-scroll py-5"
          data-testid="mobile-modal"
        >
          {navItems &&
            navItems.map(({ fields }: any, idx: number) => (
              <ModalNavCategory
                {...fields}
                setTitleExpanded={setTitleExpanded}
                titleExpanded={titleExpanded}
                key={idx}
              />
            ))}
        </div>

        {modalMobileCta && (
          <div className="fixed bottom-0 left-0 right-0 flex w-full flex-col items-center justify-center bg-[#F2F5F5] px-6 py-8">
            <CtaWidget
              {...modalMobileCta?.fields}
              id="mobile-modal-nav-cta"
              sysId={modalMobileCta?.sys?.contentType?.sys?.id}
              module="Navigation"
              errorPosition="top"
            />
          </div>
        )}
      </div>
    </div>
  );
}
